import loadable from '@loadable/component';

export { default as reducer } from './reducer';

export { STATE_NAME } from './constants';

export default loadable(() =>
  import(/* webpackChunkName: "NavBar" */ './components/NavBar'),
);
